export default "__VITE_ASSET__BaFjvM4q__"